import styled from 'styled-components';


export const DocumentList = styled.ul`
  line-height: 27px;
`;

export const DocumentLink = styled.div`
  display: flex;
  align-items: baseline;
  span {
    font-size: 12px;
  }
  a{
    margin-left: 5px;
    color: rgb(218, 156, 21);
    font-weight: bold;
  }
`;

export const File = styled.li`
  i {
    font-size: 18px;
  }
  a {
    transition: all .25s linear;

    &:hover {
      color: #edbd2f;
    }
  }
  span {
    text-decoration: underline;
  }
`;

export const DocumentWarning = styled.div`
  margin: 10px 0;
  strong {
    color: rgb(218, 156, 21);
  }
`;



// WEBPACK FOOTER //
// ./src/components/documents/index.js